import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: ({ variant }) => ({
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    left: variant ? '50%' : '',
    transform: variant ? 'translate(-50%, 0%)' : '',
    margin: '0 auto',
    bottom: variant ? '50px' : '',
    width: !variant ? '80%' : '',
    padding: !variant ? '0' : '',
    marginTop: variant ? theme.spacing(6) : '',
    marginBottom: variant ? theme.spacing(8) : '',
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      bottom: '20px',
      width: variant ? '100%' : '90%',
    },
  }),
  background: ({ variant }) => ({
    width: '100%',
    backgroundColor: variant ? 'rgb(0, 17, 35, .5)' : theme.palette.background.default,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: variant ? '2rem' : '1rem 2rem',
    borderRadius: '8px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  }),
  header: ({ variant }) => ({
    color: variant ? theme.palette.opaque.white : theme.palette.opaque.blue,
    marginBottom: variant ? theme.spacing(1) : '',
    '&.primary': {
      [theme.breakpoints.down('sm')]: {
        ...theme.typography.h6,
      },
    },
  }),
  subtitle: ({ variant }) => ({
    color: variant ? theme.palette.opaque.white : '',
  }),
  flexLeft: ({ variant }) => ({
    display: 'flex',
    gap: !variant ? '1rem' : '',
    marginTop: 'auto',
    marginBottom: 'auto',
    flexDirection: variant ? 'column' : 'row',
    width: variant ? '60%' : '',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: variant ? '100%' : '',
      alignItems: variant ? 'flex-start' : 'center',
      marginBottom: variant ? theme.spacing(2) : '',
    },
  }),
  link: ({ variant }) => ({
    padding: '0',
    marginLeft: theme.spacing(2),
    color: variant ? theme.palette.opaque.white : theme.palette.blue.main,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
    '&:hover': {
      color: variant ? theme.palette.opaque.white : '',
    },
    '&>span>svg': {
      color: variant ? theme.palette.opaque.white : theme.palette.blue.main,
    },
  }),
}))

export default useStyles
